import React from 'react';
import Tag from 'src/components/10-atoms/Tag';
import withPress from 'src/hoc/withPress';
const QuestionTopic = ({ topic, ...tagProps }) => {
    return React.createElement(Tag, { ...tagProps }, topic);
};
export default withPress(QuestionTopic);
